import React from "react"
import { Navigate, Route, Routes, useLocation } from "react-router-dom"
import Dashboard from "./dashboard"
import BookingManagement from "./bookingManagement"
import Users from "./users"
import ChargingStations from "./chargingStationManagement"
import ContentManagement from "./settings/contentManagement"
import ManageUsers from "./settings/manageUser"
import PaymentManagement from "./settings/PaymentManagement"
import AdminRole from "./settings/adminRole/index.js"
import Login from "../pages/auth/Login"
import ForgotPassword from "../pages/auth/ForgotPassword"
import Sidebar from "../components/layout/Sidebar"
import {
  ProtectedRoutes,
  UnProtectedRoutes,
  SlashRouteHandler,
} from "../lib/GlobalMethods"
import VehicleManagement from "./settings/vehicleManagement/index.js"
import ConnectorsManagement from "./settings/connectorManagement"
import BrandsManagement from "./settings/brandManagement"
import AmenitiesManagement from "./settings/amenityManagement"
import ChargerManagement from "./chargerManagement"
import ChargingStationDetails from "./chargingStationManagement/ChargingStationDetails"
import UserDetails from "./users/UserDetails"
import { useSelector } from "react-redux"
import StationReviews from "./stationReviews"
import FeeManagement from "./settings/feeManagement/index.js"
import FleetClientManagement from "./fleetManagement/fleetClientManagement"
import FleetVehicleManagement from "./fleetManagement/fleetVehicleManagement"

const AllRoutes = () => {
  const location = useLocation()
  const loginPages = ["/login", "/forgot-password"]
  const isLoginPage = loginPages.includes(location.pathname)
  const { userDetails } = useSelector((state) => state.basicInformation)

  return (
    <>
      {!isLoginPage && <Sidebar />}
      <div className={!isLoginPage ? "wrapper_app" : ""}>
        <Routes>
          <Route element={<UnProtectedRoutes />}>
            <Route exact path="/login" element={<Login />} />
            <Route exact path="/forgot-password" element={<ForgotPassword />} />
          </Route>
          {!isLoginPage && (
            <Route element={<ProtectedRoutes />}>
              <Route exact path="/" element={<SlashRouteHandler />} />
              <Route exact path="/dashboard" element={<Dashboard />} />
              <Route exact path="/booking" element={<BookingManagement />} />
              <Route exact path="/users" element={<Users />} />
              <Route exact path="/user-details/:id" element={<UserDetails />} />
              <Route
                exact
                path="/fleet-client-management"
                element={<FleetClientManagement />}
              />
              <Route
                exact
                path="/fleet-vehicle-management"
                element={<FleetVehicleManagement />}
              />
              <Route
                exact
                path="/connectors-management"
                element={<ConnectorsManagement />}
              />
              <Route
                exact
                path="/amenities-management"
                element={<AmenitiesManagement />}
              />
              <Route
                exact
                path="/brands-management"
                element={<BrandsManagement />}
              />
              <Route
                exact
                path="/charging-stations"
                element={<ChargingStations />}
              />
              <Route
                exact
                path="/stations-review"
                element={<StationReviews />}
              />
              <Route
                exact
                path="/charging-station-details/:id"
                element={<ChargingStationDetails />}
              />
              <Route
                exact
                path="/vehicle-management"
                element={<VehicleManagement />}
              />
              <Route
                exact
                path="/content-management"
                element={<ContentManagement />}
              />
              <Route exact path="/fee-management" element={<FeeManagement />} />
              <Route
                exact
                path="/payment-management"
                element={<PaymentManagement />}
              />
              {userDetails?.role === "Super Admin" ? (
                <>
                  <Route
                    exact
                    path="/manage-permissions"
                    element={<ManageUsers />}
                  />
                  <Route exact path="/admin-role" element={<AdminRole />} />
                </>
              ) : (
                <>
                  <Route
                    exact
                    path="/manage-permissions"
                    element={<Navigate to="/dashboard" />}
                  />
                  <Route
                    exact
                    path="/admin-role"
                    element={<Navigate to="/dashboard" />}
                  />
                </>
              )}
              <Route exact path="/dashboard" element={<Dashboard />} />

              <Route
                exact
                path="/charger-management"
                element={<ChargerManagement />}
              />
            </Route>
          )}
        </Routes>
      </div>
    </>
  )
}

export default AllRoutes
